import React, { useEffect, useState } from 'react'
import { useDebounceFn, useRequest } from 'ahooks'
import request from 'meinian-package/src/utils/request'
import { uuid } from 'meinian-package/src/utils'
import MNWaterfall from '../../../../component/waterfall/masonry'
import Inspiration from '../recommendCard/inspiration'
import { Filter as OfficialInspirationFilter } from '../officialInspirationFilter'

export enum OFFICIAL_INSPIRATION_TYPE {
  EXCLUSIVE='EXCLUSIVE'
}

const InspirationList = ({ cardTypeResult }) => {
  const [params, setParams] = useState({
    queryType: 'all',
    titleLike: '',
    rankStatus: 0,
  })
  const pageSize = 20
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<any>([])
  const [isEnd, setIsEnd] = useState(false)

  const onChange = (val) => {
    setParams(pre => ({ ...pre, ...val }))
    init({ ...params, ...val })
  }

  const { run, params: [start] } = useRequest((s, _params) => request.post(`/zhikuan/ins/inspiration/list-inspiration-style?start=${s}&pageSize=${pageSize}`, {
    ..._params,
    start: s,
    pageSize,
  }), {
    manual: true,
    onBefore: () => {
      setLoading(true)
    },
    onSuccess: (result:any) => {
      if (!result?.resultList?.length || start + pageSize >= result.resultCount) {
        setIsEnd(true)
      }
      const resultList = result.resultList?.map(m => ({ ...m, uuidKey: uuid() }))
      if (start === 0) {
        fetchExclusiveData().then(_result => {
          let _resultList
          if (_result.length) {
            _resultList = [_result[0], ...resultList]
          } else {
            _resultList = [...resultList]
          }
          setData(_resultList || [])
          setLoading(false)
        })
      } else {
        data.push(...resultList)
        setData([...data])
        setLoading(false)
      }
    },
    onError: () => {
      setLoading(false)
    }
  })

  const fetchExclusiveData = async () => {
    const result:any = await request.get('/zhikuan/mn/recommend/list-daily-recommend')
    return result.map(item => ({ ...item,
      coverImgUrl: item.imageUrl,
      name: item.dailyName,
      uuidKey: uuid(),
      type: OFFICIAL_INSPIRATION_TYPE.EXCLUSIVE
    }))
  }
  const { run: onEnd } = useDebounceFn(() => {
    run(start + pageSize, params)
  }, {
    wait: 300
  })

  useEffect(() => {
    init()
  }, [])

  const init = (_params = params) => {
    setIsEnd(false)
    setData([])
    run(0, _params)
  }

  return <>
    <OfficialInspirationFilter
      options={cardTypeResult.current.option}
      params={params}
      tabAllowClear={cardTypeResult.current.allowClear}
      onChange={onChange}
    />
    <MNWaterfall
      loading={loading}
      isEnd={isEnd}
      onEnd={onEnd}
      data={data}
      renderItem={Inspiration}
      gutter={16}
    />
  </>
}

export default InspirationList
